<div class="flex justify-center items-center w-8 h-8 rounded-full gray">
  <gcp-workspace-avatar
    [users]="currentUser()"
    [matMenuTriggerFor]="menu"
  ></gcp-workspace-avatar>
</div>
<mat-menu #menu="matMenu" panelClass="user-profile-menu-panel">
  <div class="user-profile-menu-content">
    <h1 class="menu-section-heading">ACCOUNT</h1>
    <div class="menu-account-row">
      <gcp-workspace-avatar
        [users]="currentUser()"
        [showTooltip]="false"
        [isClickable]="false"
        [iconSize]="IconSize.HUGE"
      ></gcp-workspace-avatar>
      <div class="menu-account-details">
        <span class="menu-user-name">
          {{ fullName() }}
        </span>
        <span class="menu-user-email">{{ currentUser()?.email }}</span>
      </div>
    </div>
  </div>
  <mat-divider class="menu-divider"></mat-divider>
  <h1 class="menu-section-heading menu-section-heading--settings">SETTINGS</h1>
  <button mat-menu-item (click)="openAccountSettings()">
    Account Settings
  </button>
  <button mat-menu-item data-cy="logout" (click)="handleLogout()">Sign out</button>
</mat-menu>
